<template>
    <div class="page">
        <section class="blk1 fz32">
          စိတ်ဝင်စားစရာဆုတွေနဲ့ ဗဟုသုတတွေရစေဖို့ Challenge Me မှာ ကစားစို့<br/>
          စမတ်ဖုန်းဆုကြီးနဲ့ အခြားဆုမဲပေါင်းများစွာကို လစဉ်ရယူလိုက်ပါ<br/>
          မှတ်ပုံတင်ရန်အတွက် ဖုန်းနံပါတ်ကို ရိုက်ထည့်ပါ<br/>
        </section>

        <div class="formbox blk3">
            <section>
                <input class="input-block" v-model="mobile" type="number" name="mobile" placeholder="Insert MPT phone Number">
            </section>
<!--            <section>-->
<!--                <input class="input-block" v-model="passwd" type="password" name="passwd" placeholder="Insert Your password">-->
<!--            </section>-->
            <section>
                <div class="btn btn-block" @click="_loginAction">ဝင်ရောက်မည်</div>
            </section>
        </div>

<!--        <section class="mt30">-->
<!--            <p class="mt10">Don't have Account? &lt;!&ndash;<a href="">Click here</a>&ndash;&gt;</p>-->
<!--            <p>Type QM send sms to 1234 </p>-->
<!--&lt;!&ndash;            <p class="mt20">Forget your password? <a href="">Click here</a></p>&ndash;&gt;-->
<!--        </section>-->

        <Footer></Footer>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Footer from './Footer'
export default {
    name: 'Loin',
    components: {Footer},
    data(){
        return{
            mobile: '',
            passwd: ''
        }
    },
    computed: {
        ...mapState(['langMap','lang'])
    },
    created(){
      if (this.$route.query.mobile){
        this.mobile = this.$route.query.mobile;
      }
    },
    methods: {
        ...mapActions(['setUserInfo']),
        // 登录
        _loginAction(){
            let reqData = {mobile: this.mobile}
            Utils.$ajax({
                type: 'post',
                url: '/login/check',
                data: reqData,
            }).done(res=>{
                if(res.code==0){
                    this.setUserInfo(res.data);
                    localStorage.A_uuid = res.data.uuid;
                    localStorage.A_token = res.data.token;
                    this.$router.push('/');
                }else if(res.code==20003){
                  this.$router.push('land');
                  // window.location.href = '#/login';
                }else{
                    this.$toast(res.msg);
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .page{
        padding: 0 1em;
    }
    .blk2{
        margin-top: rem(30);
        i{
            display: inline-block;
            width: 1.2em;
            line-height: 1.2em;
            text-align: center;
            border-radius: 50%;
            background-color: rgba(255,255,255,.3);
            vertical-align: middle;
            margin-right: .8em;
        }
    }
    .blk3{
        margin-top: rem(46);
        section{
            margin-top: rem(34);
            &:first-child{
                margin-top: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue